import * as React from "react";
import { useTl, useApiService } from "../../../../hooks";
import { useParams, useHistory } from "react-router";
import { BreedGroupDetailPage } from "./BreedGroupDetailPage";
import { PageBase, BackButton, ProtectedTabs } from "../../../../components";
import { ETLCodes } from "../../../../locales";
import { ERoutes } from "../../../../ERoutes";
import {Tab, Spinner, SpinnerSize} from "@blueprintjs/core";
import { BreedGroupApi } from "../../../../api";
import { useApiEffect } from "nsitools-react";
import { BreedGroupBreedPage } from "./BreedGroupBreedPage";
import { BreedGroupJudgePage } from "./BreedGroupJudgePage";

export interface IBreedGroupItemPageProps {}

export const BreedGroupItemPage: React.FunctionComponent<IBreedGroupItemPageProps> = (props) => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const idBreedGroup = React.useMemo(() => +id, [id]);
  const history = useHistory();
  const breedGroupApi = useApiService(BreedGroupApi);
  const [displayName, loading] = useApiEffect(() => breedGroupApi.getDisplayName(idBreedGroup), [idBreedGroup]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.BreedGroups), route: ERoutes.breedGroups },
        { text: idBreedGroup > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
      ]}
    >
      <ProtectedTabs
        id="TabsBreedGroups"
        onChange={(newTabId) => history.push(`${ERoutes.breedGroups}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.breedGroups} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<BreedGroupDetailPage idBreedGroup={idBreedGroup} editMode={state === "edit"} />}
        />
        <Tab id="breeds" title={t(ETLCodes.Breeds)} panel={<BreedGroupBreedPage />} disabled={idBreedGroup <= 0} />
        <Tab id="judges" title={t(ETLCodes.Judges)} panel={<BreedGroupJudgePage />} disabled={idBreedGroup <= 0} />
      </ProtectedTabs>
    </PageBase>
  );
};
